// https://staging2.athenabest.com/zh/support-centre/contact-us
// https://ipc-staging.abagile.com/en/contact-us
const contactUs = siteCode => {
  switch (siteCode) {
    case 'afs':
      return `support-centre/contact-us`;
    case 'ipc':
      return `contact-us`;
    case 'absg':
      return ``;
    default:
      throw new Error();
  }
};

// https://staging2.athenabest.com/zh/support-centre/faq
// https://ipc-staging.abagile.com/en/faq
const faq = siteCode => {
  switch (siteCode) {
    case 'afs':
      return `support-centre/faq`;
    case 'ipc':
      return `faq`;
    case 'absg':
      return ``;
    default:
      throw new Error();
  }
};
// https://staging2.athenabest.com/zh/policy-disclaimer#policy
// https://ipc-staging.abagile.com/en/policy-disclaimer#policy
const privacyLink = `policy-disclaimer#policy`;

// https://staging2.athenabest.com/zh/policy-disclaimer#disclaimer
// https://ipc-staging.abagile.com/en/policy-disclaimer#disclaimer
const disclaimerLink = `policy-disclaimer#disclaimer`;

// https://staging2.athenabest.com/zh/
const home = ``;

export {contactUs, faq, privacyLink, disclaimerLink, home};
